import BlueFuelPump from "./BlueFuelPump";

export default BlueFuelPump